export type UserRequestMessages = {
  // Success Messages
  deleteUserSucess: string;
  createUserSuccess: string;
  updateUserSuccess: string;
  deactivatedUserSuccess: string;
  activatedUserSuccess: string;
  insertUserProfileSuccess: string;
  removeUserProfileSuccess: string;

  // Error Messages
  createUserError: string;
  updateUserError: string;
  userNotFoundError: string;
  userNotFoundDescription: string;
  userNotFoundAlt: string;
  userErrorToLoad: string;
  deactivatedUserError: string;
  activatedUserError: string;
  inserUserProfileError: string;
  emailNotVerified: string;
};

export const USER_REQUEST_MESSAGES: UserRequestMessages = {
  // Success Messages
  deleteUserSucess: "Usuario deletado com sucesso.",
  createUserSuccess: "Usuário criado com sucesso",
  updateUserSuccess: "Usuário editado com sucesso",
  deactivatedUserSuccess: "Usuário desativado com sucesso",
  activatedUserSuccess: "Usuário ativado com sucesso",
  insertUserProfileSuccess: "Permissão alterada com sucesso",
  removeUserProfileSuccess: "Perfil de usuário removido com sucesso",

  // Error Messages
  createUserError: "Erro ao criar usuário",
  updateUserError: "Erro ao editar usuário",
  userNotFoundError: "Usuários não encontrados",
  userNotFoundDescription:
    "Não conseguimos encontrar nenhum usuário, recarregue a página e tente novamente",
  userNotFoundAlt: "Imagem indicando erro ao buscar usuários",
  userErrorToLoad: "Erro ao buscar usuários",
  deactivatedUserError: "Erro ao desativar usuário",
  activatedUserError: "Erro ao ativar usuário",
  inserUserProfileError: "Erro ao alterar permissão",
  emailNotVerified: "Email não verificado",
};
